import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";

export default function AutoStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField label="Marca" value={data.marca} onChange={update("marca")} placeholder="ex: Volkswagen" required half error={errors.marca} />
      <InputField label="Model" value={data.model} onChange={update("model")} placeholder="ex: Golf 7" required half error={errors.model} />
      <InputField label="An fabricatie" value={data.anFabricatie} onChange={update("anFabricatie")} placeholder="ex: 2018" type="number" required half error={errors.anFabricatie} />
      <InputField label="Nr. inmatriculare" value={data.nrInmatriculare} onChange={update("nrInmatriculare")} placeholder="ex: B 123 ABC" half error={errors.nrInmatriculare} />
      <InputField label="Serie sasiu (VIN)" value={data.serieSasiu} onChange={update("serieSasiu")} placeholder="ex: WVWZZZ3CZWE123456" required error={errors.serieSasiu} />
      <InputField label="Nr. motor" value={data.nrMotor} onChange={update("nrMotor")} placeholder="ex: ABC123456" half error={errors.nrMotor} />
      <InputField label="Culoare" value={data.culoare} onChange={update("culoare")} placeholder="ex: Negru" half error={errors.culoare} />
      <SelectField
        label="Combustibil"
        value={data.combustibil}
        onChange={update("combustibil")}
        options={[
          { value: "benzina", label: "Benzina" },
          { value: "motorina", label: "Motorina" },
          { value: "GPL", label: "GPL" },
          { value: "electric", label: "Electric" },
          { value: "hibrid", label: "Hibrid" },
        ]}
        half
      />
      <InputField label="Capacitate cilindrica (cmc)" value={data.capacitateCilindrica} onChange={update("capacitateCilindrica")} placeholder="ex: 1968" type="number" half error={errors.capacitateCilindrica} />
      <SelectField
        label="Declaratie kilometraj"
        value={data.kmDeclaratie}
        onChange={update("kmDeclaratie")}
        options={[
          { value: "real", label: "Kilometraj real (confirmat de vanzator)" },
          { value: "estimativ", label: "Kilometraj estimativ" },
          { value: "necunoscut", label: "Kilometraj necunoscut" },
        ]}
        half
      />
      {data.kmDeclaratie !== "necunoscut" && (
        <InputField
          label={data.kmDeclaratie === "estimativ" ? "Km afisati pe bord" : "Km rulati"}
          value={data.kmRulati}
          onChange={update("kmRulati")}
          placeholder="ex: 150000"
          type="number"
          required
          half
          error={errors.kmRulati}
        />
      )}
    </div>
  );
}
